// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyDvd9ZEqHEkHjHR4CCJCwKv622E0qCLxTY',
  authDomain: 'qmath-practice.firebaseapp.com',
  projectId: 'qmath-practice',
  storageBucket: 'qmath-practice.appspot.com',
  messagingSenderId: '795621687507',
  appId: '1:795621687507:web:ea0084a7da528f19339426',
  measurementId: 'G-H0N6JYQ3F4',
};

export default firebaseConfig;
